import { Box, Container, Typography } from "@mui/material"
import React from 'react'
import { useTranslation } from "react-i18next"
import Animator from "../Aminator/Animator"
export default function AboutContent() {
    const { t } = useTranslation();
    return (
        <Box className="py-5 md:py-10 bg-[#FCFCFC] relative px-2 md:px-[56px] overflow-hidden">

            <Container maxWidth="xl">
                <Box className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
                    {/* Left Column - Headline */}
                    <Animator variant="slide" direction="right" timeout={800} delay={300}>
                    <Box className="">
                        <Typography
                            variant="h2"
                            className="text-gray-900 leading-tight border-r-4 border-[#E2E2E2] pr-8 "
                            sx={{
                                fontSize: { xs: "2rem", md: "2.5rem" },
                                fontWeight: 600,
                                lineHeight: 1.4,
                                fontFamily: "'Montserrat', sans-serif",

                            }}
                        >
                            {t("about.content.title")}
                        </Typography>
                    </Box>
                    </Animator>

                    {/* Right Column - Content */}
                    <Animator variant="slide" direction="left" timeout={800} delay={300}>
                    <Box className="space-y-6">
                        <Typography
                            variant="body1"
                            className="text-[#667085] leading-relaxed "
                            sx={{
                                fontSize:{xs:"16px", md:"20px"},
                                lineHeight: 1.4,
                                fontWeight: 400,
                                fontFamily: "'Montserrat', sans-serif",

                            }}
                        >
                            {t("about.content.text")}
                        </Typography>

                        
                       
                    </Box>
                    </Animator>
                </Box>
            </Container>
        </Box>
    )
}
